/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTableGroups200ResponseInner
 */
export interface GetTableGroups200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetTableGroups200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTableGroups200ResponseInner
     */
    tableIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetTableGroups200ResponseInner
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof GetTableGroups200ResponseInner
     */
    max: number;
    /**
     * 
     * @type {string}
     * @memberof GetTableGroups200ResponseInner
     */
    reservationPriority: GetTableGroups200ResponseInnerReservationPriorityEnum;
}


/**
 * @export
 */
export const GetTableGroups200ResponseInnerReservationPriorityEnum = {
    Preferred: 'preferred',
    Standard: 'standard',
    Low: 'low',
    Unreservable: 'unreservable'
} as const;
export type GetTableGroups200ResponseInnerReservationPriorityEnum = typeof GetTableGroups200ResponseInnerReservationPriorityEnum[keyof typeof GetTableGroups200ResponseInnerReservationPriorityEnum];


/**
 * Check if a given object implements the GetTableGroups200ResponseInner interface.
 */
export function instanceOfGetTableGroups200ResponseInner(value: object): value is GetTableGroups200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tableIds' in value) || value['tableIds'] === undefined) return false;
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('reservationPriority' in value) || value['reservationPriority'] === undefined) return false;
    return true;
}

export function GetTableGroups200ResponseInnerFromJSON(json: any): GetTableGroups200ResponseInner {
    return GetTableGroups200ResponseInnerFromJSONTyped(json, false);
}

export function GetTableGroups200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTableGroups200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tableIds': json['tableIds'],
        'min': json['min'],
        'max': json['max'],
        'reservationPriority': json['reservationPriority'],
    };
}

export function GetTableGroups200ResponseInnerToJSON(json: any): GetTableGroups200ResponseInner {
    return GetTableGroups200ResponseInnerToJSONTyped(json, false);
}

export function GetTableGroups200ResponseInnerToJSONTyped(value?: GetTableGroups200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tableIds': value['tableIds'],
        'min': value['min'],
        'max': value['max'],
        'reservationPriority': value['reservationPriority'],
    };
}

